import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bf9299a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "custom-day-week" }
const _hoisted_3 = { class: "icons" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "custom-month-year-component" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createBlock(_component_VueDatePicker, {
    ref: "datePicker",
    modelValue: _ctx.deliveryDate,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.deliveryDate) = $event)),
      _ctx.onDateSelection
    ],
    "auto-apply": true,
    "action-row": { showNow: false, showPreview: false },
    "enable-time-picker": false,
    config: {keepActionRow: false, onClickOutside: false},
    "hide-offset-dates": true,
    "allowed-dates": _ctx.getAvailableDates(),
    locale: _ctx.localeValue,
    clearable: false,
    "min-date": _ctx.availableDate,
    "month-name-format": "long",
    format: "dd.MM.yyyy",
    "calendar-class-name": "custom-calendar",
    "menu-class-name": "custom-menu",
    "input-class-name": _ctx.calenderClass,
    "day-class": _ctx.getDayClass,
    markers: _ctx.markers,
    onClosed: _ctx.onCalendarClose,
    onOpen: _ctx.onCalendarOpen,
    onFocus: _ctx.onCalendarOpen,
    onBlur: _ctx.onCalendarClose
  }, {
    "input-icon": _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.changeCalenderBgColor ? _ctx.CalendarDark : _ctx.CalendarIcon 
      }, null, 8, _hoisted_1)
    ]),
    "calendar-header": _withCtx(({ index }) => [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.dayOfWeek[index]), 1)
    ]),
    "month-year": _withCtx(({
        month,
        year,
        months,
        handleMonthYearChange
    }) => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "custom-icon",
          onClick: ($event: any) => (handleMonthYearChange(false))
        }, [
          _createElementVNode("img", { src: _ctx.ChevronLeftIcon }, null, 8, _hoisted_5)
        ], 8, _hoisted_4),
        _createElementVNode("div", _hoisted_6, _toDisplayString(months !== undefined && month !== undefined ? months[month].text : '') + " " + _toDisplayString(year), 1),
        _createElementVNode("span", {
          class: "custom-icon",
          onClick: ($event: any) => (handleMonthYearChange(true))
        }, [
          _createElementVNode("img", { src: _ctx.ChevronRightIcon }, null, 8, _hoisted_8)
        ], 8, _hoisted_7)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "allowed-dates", "locale", "min-date", "input-class-name", "day-class", "markers", "onClosed", "onOpen", "onFocus", "onBlur", "onUpdate:modelValue"]))
}